var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocationActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 513368"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.20848 6.5C6.03933 6.5 6.71286 5.82843 6.71286 5C6.71286 4.17157 6.03933 3.5 5.20848 3.5C4.37764 3.5 3.7041 4.17157 3.7041 5C3.7041 5.82843 4.37764 6.5 5.20848 6.5Z",
    stroke: "#0A7F8F",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.20894 1C4.14498 1 3.12459 1.42143 2.37226 2.17157C1.61992 2.92172 1.19727 3.93913 1.19727 5C1.19727 5.946 1.39885 6.565 1.94946 7.25L5.20894 11L8.46843 7.25C9.01904 6.565 9.22062 5.946 9.22062 5C9.22062 3.93913 8.79797 2.92172 8.04563 2.17157C7.29329 1.42143 6.27291 1 5.20894 1Z",
    stroke: "#0A7F8F",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationActive);
export default __webpack_public_path__ + "static/media/location_active.ccbbd6de024c12c0f52dd000b2aef58b.svg";
export { ForwardRef as ReactComponent };